import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

// export const tempToken = (token: any) => {
//   const { appAccessToken, appIdToken, userAccessToken, userIdToken } = token
//   const BASE_URL = window?._env_?.REACT_APP_BASE_URL ?? ''
//   const CHANNEL_ID = window?._env_?.REACT_APP_CHANNEL_ID ?? ''
//   return {
//     baseUrl: `${BASE_URL}`,
//     timeOut: 60000,
//     headers: {
//       'Content-Type': 'application/json',
//       'X-Channel-ID': CHANNEL_ID,
//       'x-trace-id': generateRandomString(20),
//       'X-Api-Key': 'kahsbfkb',
//       // 'X-DEVICE-INFO': getDeviceInfo(mobileNumber),
//       'x-app-access-token': appAccessToken || '', //not required.
//       'x-appid-token': appIdToken || '',
//       // 'x-user-access-token': userAccessToken || '',
//     },
//     retryCount: 0,
//   }
// }

const addUser = (tokens: any, reqBody: any) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    // config: tempToken(tokens),
    apiPath: APIEndPoints.addUser,
    method: 'POST',
    cache: false,
    body: reqBody,
  }
  return executeRequest(request).then(({ data }) => {
    return data?.data
  })
}

export { addUser }
